import React from "react";
import Sidebar from "./Sidebar";
import AIOverview from "./AIOverview";

function AIReviewPage() {
  return (
    <div className="app-shell">
      <Sidebar />
      <main className="main-content-area">
        <div className="page-header">
          <div>
            <h1 className="page-title">AI Review</h1>
            <p className="page-subtitle">Your personal trading coach and execution reviewer.</p>
          </div>
        </div>

        <AIOverview selectedDate="" />
      </main>
    </div>
  );
}

export default AIReviewPage;